/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S13_HeadingInputs */

const tr_mesafeli_s13_heading = /** @type {(inputs: Mesafeli_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Fesih ve Sona Erme`)
};

const en_mesafeli_s13_heading = /** @type {(inputs: Mesafeli_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Termination and Expiry`)
};

const de_mesafeli_s13_heading = /** @type {(inputs: Mesafeli_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Kündigung und Beendigung`)
};

const ru_mesafeli_s13_heading = /** @type {(inputs: Mesafeli_S13_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`13. Расторжение и прекращение`)
};

/**
* | output |
* | --- |
* | "13. Termination and Expiry" |
*
* @param {Mesafeli_S13_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s13_heading = /** @type {((inputs?: Mesafeli_S13_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S13_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s13_heading(inputs)
	if (locale === "de") return de_mesafeli_s13_heading(inputs)
	if (locale === "ru") return ru_mesafeli_s13_heading(inputs)
	return tr_mesafeli_s13_heading(inputs)
});